import { useEffect, Suspense } from "react"
import { Routes, Route, useLocation, Navigate, useNavigate, matchPath } from "react-router-dom"
import { dir } from "./utils/config/directory"
import { myTitles } from "./utils/config/titles"
import { publicRoutes, privateRoutes } from "./utils/config/routes"
import { refreshTokenAction } from "./utils/redux/refreshTokenAction"
import FallbackLoading from "./utils/plugin/FallbackLoading"

const App = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const token = localStorage.getItem("token")
    
    // 🔒 Disable right click, copy, cut, paste
    useEffect(() => {
        const handleContextMenu = (e) => e.preventDefault()
        const handleCopy = (e) => e.preventDefault()
        const handleCut = (e) => e.preventDefault()
        const handlePaste = (e) => e.preventDefault()
        document.addEventListener("contextmenu", handleContextMenu)
        document.addEventListener("copy", handleCopy)
        document.addEventListener("cut", handleCut)
        document.addEventListener("paste", handlePaste)
        document.body.style.userSelect = "none"
        return () => {
            document.removeEventListener("contextmenu", handleContextMenu)
            document.removeEventListener("copy", handleCopy)
            document.removeEventListener("cut", handleCut)
            document.removeEventListener("paste", handlePaste)
            document.body.style.userSelect = "auto"
        }
    }, [])

    useEffect(() => {
        document.title = `JD | ${myTitles(location.pathname)}`
        const isPrivateRoute = privateRoutes.some((route) =>
            matchPath({ path: route.path, end: true }, location.pathname)
        )
        if (isPrivateRoute && token) {
            refreshTokenAction(token, navigate)
        }
    }, [location.pathname, navigate])

    const Protected = ({ children }) => {
        if (!token) {
            return <Navigate to={`${dir()}/login`} />
        }
        return children
    }

    return (
        <Suspense fallback={<FallbackLoading />}>
            <Routes>
                {!token && publicRoutes.map((route) => (
                    <Route key={route.path} path={route.path} element={route.element} />
                ))}
                {privateRoutes.map((route) => (
                    <Route key={route.path} path={route.path} element={<Protected>{route.element}</Protected>}/>
                ))}
            </Routes>
        </Suspense>
    )
}

export default App